export default "__VITE_ASSET__G1$AXd4x__"